import { Component } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { AppState } from '../../app.service';
import { Select } from '@ngxs/store';
import { ApplicationState } from 'src/app/state/app.state';
import { Observable } from 'rxjs';

@Component({
    selector: 'footer',
    templateUrl: 'footer.component.html',
    styleUrls: [`./footer.component.css`],
    standalone: false
})
export class FooterComponent {
    public storeUrl: string = `${AppSettings.PUBLICATIONS_STORE}`;

    @Select(ApplicationState.popupMode)
    popupMode$: Observable<boolean>;

    constructor(private appService: AppState) { }

    public getAssetsLink(path: string): string {
        return this.appService.getAssetsLink(path, true);
    }
}
